import { useCallback, useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useAutomaticSummarization } from '../../../hooks/useAutomaticSummarization'
import useStyles from './automaticallySummarizeStyle'
import Switch from '../../atoms/inputs/switch'
import { useSelector } from 'react-redux'
import CircularProgress from '../../atoms/feedback/circularProgress'

export const AutomaticallySummarize = ({ isDisabled }) => {
  const size = useSelector((state) => state.preferences)
  const { t } = useTranslation()
  let useStylesParams = {
    size: size,
  }
  const classes = useStyles(useStylesParams)

  const {
    isAutomaticallyGenerateSummaryEnabled,
    save,
    isLoading: isLoadingAutomaticSummarization,
    firstTime,
  } = useAutomaticSummarization()

  const [isLoading, setIsLoading] = useState(true)

  const userValue = useMemo(
    () => isAutomaticallyGenerateSummaryEnabled || firstTime,
    [isAutomaticallyGenerateSummaryEnabled, firstTime]
  )

  const disabled = useMemo(
    () => isDisabled || isLoadingAutomaticSummarization,
    [isDisabled, isLoadingAutomaticSummarization]
  )

  const handleSubmit = useCallback(
    async (value) => {
      setIsLoading(true)
      save(!value)
    },
    [save]
  )

  useEffect(() => {
    if (!isLoadingAutomaticSummarization) setIsLoading(false)
  }, [isLoadingAutomaticSummarization])

  return (
    <div className={classes.container}>
      <p className={classes.text}>
        {t('summary.Automatically summarize upcoming conversations')}
      </p>
      {isLoading ? (
        <CircularProgress size={24} />
      ) : (
        <Switch
          name="theme"
          color="primary"
          onChange={(event) => handleSubmit(!event.target.checked)}
          disabled={disabled}
          checked={userValue}
        />
      )}
    </div>
  )
}
